<script setup lang="ts">
import { supplierClassificationClient } from '#shared/services/api/supplier-classification.client'
import QualitativeDimensions from '#taxonomy/components/QualitativeDimensions.vue'
import type { Dimension, DimensionBody, DimensionResource } from '#taxonomy/lib/resource'
import { ICONS } from '#utils/icons'

definePage({
  meta: { requiresAuth: true, title: 'Project Dimensions' },
})

const resource: DimensionResource = {
  queryKey: 'project-dimensions',
  icon: ICONS.projectDimensions,
  title: 'Project Dimensions',
  description:
    'The dimensions used to categorize qualitative project information — notes, insights, and conversations collected across Deducta.',
  scopeNote: 'Every organization uses these dimensions to categorize project qualitative data.',
  dialogHint:
    'A dimension is a category used to classify project notes and insights — for example scope, timeline, or stakeholder.',
  deleteNote: 'be available to categorize project qualitative data across',
  list: async (): Promise<Dimension[]> => {
    const { data } = await supplierClassificationClient.GET('/api/admin/report-dimensions')
    return data ?? []
  },
  create: async (body: DimensionBody) => {
    const r = await supplierClassificationClient.POST('/api/admin/report-dimensions', { body })
    return r.data!
  },
  update: async (id: string, body: DimensionBody) => {
    const r = await supplierClassificationClient.PUT('/api/admin/report-dimensions/{id}', {
      params: { path: { id } },
      body,
    })
    return r.data!
  },
  remove: async (id: string) => {
    await supplierClassificationClient.DELETE('/api/admin/report-dimensions/{id}', {
      params: { path: { id } },
    })
  },
}
</script>

<template>
  <QualitativeDimensions :resource="resource" />
</template>
